import React from 'react';
import { motion } from 'framer-motion';
import { COLORS } from '../constants';

const AnimatedIcon = ({ Icon, size = 28, color = COLORS.accent }) => (
  <motion.div
    initial={{ scale: 0.8, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    whileHover={{ scale: 1.3, rotate: 10 }}
    transition={{ duration: 0.3, type: "spring", stiffness: 300 }}
  >
    <Icon size={size} color={color} />
  </motion.div>
);

export default AnimatedIcon;